export default __webpack_public_path__ + "static/media/if-black-hamburger-icon2.ed57d301.webp";